import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/index.css'
import './styles/oneinc.css'
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

datadogRum.init({
  applicationId: '298adbaf-087c-4fc3-be00-137c7d7f4ca2',
  clientToken: 'pub3b4f81a58840ca60f28e9a3d33ad0ef7',
  site: 'datadoghq.com',
  service: 'react-oneinc',
  env: 'staging',
  sessionSampleRate:  100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  plugins: [reactPlugin({ router: true })],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
